import { GroupMsgOption } from '@/modules/group/modules/groups/domain/models/GroupOptions'

import { axios, Response } from '../index'

export type Body = {
  newGroupSendPermission: string
  newGroupVisibility: string
  postEdit: 'CREATOR_ONLY' | 'ANYONE'
  expirationDate?: string | null
  clonePostGroupId?: string | null
  groupPermissionFixed?: GroupMsgOption
  commentBlocked?: GroupMsgOption
  automaticDeletedPost?: GroupMsgOption
}

const updateGroupOptions = (groupId: string, body: Body): Response<null> => {
  return axios.put(`/v1/groups/${groupId}/options`, body)
}

export default updateGroupOptions
